module.exports = __webpack_public_path__ + "media/activity/star-074c4f2e.svg";